import { loadOnetrustJS } from '~/utils/scripts';

function interactionEvent(eventName: string, payload: Record<string, unknown>) {
    const currentWindow = window as Window & { dataLayer?: Array<Record<string, unknown>> };
    if (Array.isArray(currentWindow.dataLayer)) {
        currentWindow.dataLayer.push({ event: eventName, ...payload });
    }
}

class OneTrustLoadError extends Error { }

const onetrustURL = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';

/** Initialise le script OneTrust au demarrage de l'application. */
export async function initOneTrust() {
    try {
        await loadOnetrustJS(onetrustURL);
    } catch {
        console.error(new OneTrustLoadError('Impossible de charger OneTrust'));
    }
}

/** Ouvre le panneau de configuration OneTrust quand il est disponible. */
export function handleCookieClick() {
    if (window.OneTrust) {
        window.OneTrust.ToggleInfoDisplay();
        interactionEvent('click', {
            click_type: 'menu secondaire',
            link_url: null,
            link_text: 'Personnaliser les temoins',
        });
        return;
    }

    // Fallback si le script OneTrust expose seulement le trigger CSS.
    const trigger = document.querySelector<HTMLElement>('.ot-sdk-show-settings');
    trigger?.click();
}
